
import React, { useEffect, useState } from "react";
import axios from '@utils/axios'
import { toast } from 'react-toastify';
import Translate from '../components/translate/conf';
import ReactDOMServer from 'react-dom/server'
import { Translation } from 'react-i18next';
import { Checkbox } from "@app/components/index";
import ModalLoading from "@app/components/modal-loading/modal-loading";

export default class RebootPage extends React.Component {
  constructor(props) {
    super(props)
    this.checkIfRebooting();
  }

  timerId = -1;
  state = {
    mLoading: false,
    yesIdo: false
  }

  checkIfRebooting = async () => {
    try {
      let response = await axios('/api/systeminfo');
      let reboot = response.data.data.reboot;
      let err = response.data.err;
      if (err === '' && reboot == 1) {
        this.waitProcess(true)
      }
    } catch (e) {
      console.log(e)
    }
  }

  handleYesIdo = value => {
    this.setState({
      yesIdo: value,
    });
  }

  monitorRebooting = async () => {
    let err = '';
    try {
      let response = await axios({ url: '/api/systeminfo', timeout: 900 });
      err = response.data.err;
    } catch (e) {
      err = e;
    }

    if (err === 'Unauthorized access') {
      toast.success(<Translate transVar="ManagementCard.ApplySuccess" />)
      this.waitProcess(false)
      setTimeout(() => axios('/api/login').catch(), 3000);
    }
  }

  waitProcess = (en) => {
    if (en) {
      if (this.timerId > 0) return;
      this.timerId = setInterval(this.monitorRebooting, 1000)
      this.setState({ mLoading: true });
    } else {
      if (this.timerId === -1) return;
      clearInterval(this.timerId);
      this.timerId = -1;
      this.setState({ mLoading: false });
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    if (this.state.yesIdo === false) {
      toast.error(<Translate transVar='ManagementCard.Reboot.DontApply' />)
      return false;
    }
    var bodyFormData = {
      reboot: '1'
    }
    axios({
      method: 'post',
      url: '/api/systeminfo',
      data: bodyFormData,
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((response) => {
      if (response.data.err !== undefined && response.data.err === "") {
        this.waitProcess(true)
      } else {
        console.log(response.data.err)
        let label = ReactDOMServer.renderToString(<Translate transVar='error.label' />)
        toast.error(label + response.data.err)
      }
    }).catch((err) => {
      //handle error
      console.log(err)
      let label = ReactDOMServer.renderToString(<Translate transVar='error.label' />)
      toast.error(label + err)
    });
  }
  render() {

    return (
      <>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1><Translate transVar='menusidebar.label.ManagementCard.Reboot' /></h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Translate transVar='menusidebar.label.ManagementCard.Parent' />
                  </li>
                  <li className="breadcrumb-item active">
                    <Translate transVar='menusidebar.label.ManagementCard.Reboot' />
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-5">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title"><Translate transVar='menusidebar.label.ManagementCard.Reboot' /></h3>
                  </div>
                  <ModalLoading show={this.state.mLoading} />
                  <form onSubmit={this.handleSubmit}>
                    <div className="card-body">
                      <div className="form-group">
                        <label><Translate transVar='ManagementCard.Reboot.AskQuestion' /></label>
                      </div>
                      <div className="form-group">
                        <Translation>
                          {
                            t => <Checkbox checked={this.state.yesIdo} label={t('ManagementCard.YesIdo')} onChange={this.handleYesIdo} />
                          }
                        </Translation>
                      </div>
                      <div className="form-group">
                        <i className="info">- <Translate transVar='ManagementCard.AfterRebootLogout' /></i>
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary"><Translate transVar='Button.Apply' /></button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }
}
